import { Injectable } from '@angular/core';

import { NavController } from '@ionic/angular';
import { AuthService } from '@app/core/services';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(
    private _authService: AuthService,
    private _navController: NavController,
  ) {}

  async canActivate() {
    const isAuthenticated = await this._authService.isAuthenticated();
    if (!isAuthenticated) {
      this._navController.navigateRoot('signout', {
        animated: true,
        animationDirection: 'back',
      });
    }
    return isAuthenticated;
  }
}
